'use strict'

import crypto from '@/libs/crypto'

const keyDomain = 'ifblock'
const useCrypto = process.env.NODE_ENV === 'production'

const sessionGetItem = (key) => {
  const fullKey = `${keyDomain}_${key}`
  if (!useCrypto) return sessionStorage.getItem(fullKey)
  const encrypted = sessionStorage.getItem(fullKey)
  try {
    return crypto.decrypt(encrypted)
  } catch (e) {
    log(e.message)
  }
}

const sessionSetItem = (key, value) => {
  const fullKey = `${keyDomain}_${key}`
  if (!useCrypto) return sessionStorage.setItem(fullKey, value)
  try {
    return sessionStorage.setItem(fullKey, crypto.encrypt(value))
  } catch (e) {
    log(e.message)
  }
}

const sessionRemoveItem = (key) => {
  const fullKey = `${keyDomain}_${key}`
  return sessionStorage.removeItem(fullKey)
}

const localGetItem = (key) => {
  const fullKey = `${keyDomain}_${key}`
  if (!useCrypto) return localStorage.getItem(fullKey)
  const encrypted = localStorage.getItem(fullKey)
  try {
    return crypto.decrypt(encrypted)
  } catch (e) {
    log(e.message)
  }
}

const localSetItem = (key, value) => {
  const fullKey = `${keyDomain}_${key}`
  if (!useCrypto) return localStorage.setItem(fullKey, value)
  try {
    return localStorage.setItem(fullKey, crypto.encrypt(value))
  } catch (e) {
    log(e.message)
  }
}

const localRemoveItem = (key) => {
  const fullKey = `${keyDomain}_${key}`
  return localStorage.removeItem(fullKey)
}

export default {
  session: {
    getItem: sessionGetItem,
    setItem: sessionSetItem,
    removeItem: sessionRemoveItem
  },
  local: {
    getItem: localGetItem,
    setItem: localSetItem,
    removeItem: localRemoveItem
  }
}
